export const SELECT_STORES_TABLE_ID = 31;

export const REVIEW_ORDER_TABLE_ID = 42;
